import { render, staticRenderFns } from "./formComponentPanel.vue?vue&type=template&id=4bcf1fcb&"
import script from "./formComponentPanel.vue?vue&type=script&lang=js&"
export * from "./formComponentPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports